import { createAction, props } from '@ngrx/store';

import { MapActionTypes } from '../domain/events/map.events';
import { MapLocation, MapParams } from '../domain/models/map.models';

import { MapTooltip } from './map.state';

export const LoadMapValues = createAction(
    MapActionTypes.LOAD_VALUES,
    props<{ values: MapLocation[] }>()
);

export const SetMapSelectedShop = createAction(
    MapActionTypes.SET_SELECTED_SHOP,
    props<{ value: MapLocation; skipTooltip?: boolean; source?: 'list' | 'map' }>()
);

export const RemoveMapSelectedShop = createAction(
    MapActionTypes.REMOVE_SELECTED_SHOP
);

// #region TOOLTIP COMMANDS
export const ToggleMapStateTooltip = createAction(
    MapActionTypes.TOOGLE_STATE_TOOLTIP,
    props<{ value: boolean }>()
);

export const SetMapValueTooltip = createAction(
    MapActionTypes.SET_VALUE_TOOLTIP,
    props<{ value: MapLocation }>()
);

export const SetMapTooltipState = createAction(
    MapActionTypes.SET_STATE_TOOLTIP,
    props<{ value: MapTooltip }>()
);
// #emdregion TOOLTIP COMMANDS

export const SetMapParams = createAction(
    MapActionTypes.SET_PARAMS,
    props<{ params: MapParams }>()
);

export const ConfirmSelectedPlace = createAction(
    MapActionTypes.CONFIRM_SELECTED_PLACE,
    props<{ placeId: string }>()
);

export const ConfirmSelectedDeliveryPoint = createAction(
    MapActionTypes.CONFIRM_SELECTED_DELIVERYPOINT,
    props<{ deliveryPoint: MapLocation }>()
);

export const ResetMapState = createAction(MapActionTypes.RESET_STATE);

export const StartMapEffects = createAction(MapActionTypes.START_EFFECTS);

export const StopMapEffects = createAction(MapActionTypes.STOP_EFFECTS);

export const MapMarkerClickedEvent = createAction(
    MapActionTypes.MAP_MARKER_CLICKED,
    props<{ clickedLocation: MapLocation }>()
);
